import { FAN_ANGLE, FAN_RADIUS, WINDOW } from './constants';
import { COUNT, PRODUCTS, type Product } from './products';

// active(무한 정수)를 실제 제품 인덱스(0..COUNT-1)로 매핑 (음수 안전)
export function productAt(index: number): Product {
  return PRODUCTS[((index % COUNT) + COUNT) % COUNT];
}

// active 주변 렌더 윈도우의 인덱스 배열 (key 안정성을 위해 절대 인덱스 사용)
export function windowIndices(active: number): number[] {
  return Array.from({ length: WINDOW * 2 + 1 }, (_, k) => active - WINDOW + k);
}

// 등장 스태거 순서(slot): 중앙에서 가까운 순으로 왼쪽부터.
// 1번째 왼쪽 → 2번째 왼쪽 → 1번째 오른쪽 → 2번째 오른쪽
export function entranceSlot(
  offset: number,
  interactiveOffset: number,
): number {
  return offset < 0 ? Math.abs(offset) - 1 : interactiveOffset + offset - 1;
}

// 중앙에서 offset 칸 떨어진 카드의 위치·회전·zIndex.
// x=R·sinθ, y=R·(1−cosθ) 로 원호 위에 놓고, θ 만큼 회전시킨다.
export function fanTransform(
  offset: number,
  radius: number = FAN_RADIUS,
  angle: number = FAN_ANGLE,
) {
  const rad = (offset * angle * Math.PI) / 180;
  return {
    x: Math.round(radius * Math.sin(rad)),
    y: Math.round(radius * (1 - Math.cos(rad))),
    rotate: offset * angle,
    zIndex: 30 - Math.abs(offset),
  };
}
